import { updateSurveyArea } from "./surveyStorage";
import { submitNeozone, submitOpenzone, submitFinal } from "./surveySubmit";

function getCheckedValue(container: ParentNode): string | null {
  const checked = container.querySelector('input[type="checkbox"]:checked') as HTMLInputElement | null;
  return checked?.value || null;
}

export const surveyController = {
  getRatingValueByInputId(inputId: string): number {
    const input = document.getElementById(inputId) as HTMLInputElement | null;
    return Number(input?.value || 1);
  },

  saveNeoZoneBranch(selectedBranch: "a" | "b" | null) {
    const branchMap: Record<"a" | "b", string> = {
      a: "yes",
      b: "no",
    };

    updateSurveyArea("neozone", {
      visitedBooth: selectedBranch ? branchMap[selectedBranch] : null,
    });
  },

  async saveNeoZoneRatings() {
    const storedBranch =
      selectedBranchFromStorage();

    const data = {
      area: "neozone",
      visitedBooth: storedBranch,
      whyDitintEvaluate:
        (document.getElementById("whyDitintEvaluate") as HTMLTextAreaElement | null)?.value.trim() || null,
      gamesSelection: this.getRatingValueByInputId("gamesSelection"),
      lines: this.getRatingValueByInputId("lines"),
      gift: this.getRatingValueByInputId("gift"),
      service: this.getRatingValueByInputId("service"),
      comment: (document.getElementById("surveyNvidiaOptional") as HTMLTextAreaElement | null)?.value.trim() || "",
    };

    await submitNeozone(data);
  },

  async saveOpenZoneRatings() {
    const data = {
      area: "openzone",
      graphics: this.getRatingValueByInputId("graphics"),
      gameplay: this.getRatingValueByInputId("gameplay"),
      fun: this.getRatingValueByInputId("fun"),
      challenge: this.getRatingValueByInputId("challenge"),
      ambience: this.getRatingValueByInputId("ambience"),
      comment: (document.getElementById("surveyInvincibleOptional") as HTMLTextAreaElement | null)?.value.trim() || "",
    };

    await submitOpenzone(data);
  },

  async saveFinalSurvey() {
    const wrappers = document.querySelectorAll("#experienceSurvey .options-container") as NodeListOf<HTMLElement>;

    const motivationWrapper = wrappers[1];
    const worldWrapper = wrappers[2];

    const motivationValue = getCheckedValue(motivationWrapper);
    const worldValue = getCheckedValue(worldWrapper);

    const data = {
      area: "final",
      overallExperience: this.getRatingValueByInputId("overallExperience"),
      motivation: motivationValue,
      favoriteWorld: worldValue,
      comment: (document.getElementById("surveyFinalOptional") as HTMLTextAreaElement | null)?.value.trim() || "",
    };

    await submitFinal(data);
  },

  setupFinalSurveyCheckboxes() {
    const groups = document.querySelectorAll("#experienceSurvey .options-container");

    groups.forEach((group) => {
      const checkboxes = group.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;

      checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          if (!checkbox.checked) return;

          checkboxes.forEach((other) => {
            if (other !== checkbox) {
              other.checked = false;
            }
          });
        });
      });
    });
  },
};

function selectedBranchFromStorage(): string | null {
  try {
    const raw = localStorage.getItem("gamescom-surveys-v2");
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return parsed?.neozone?.visitedBooth ?? null;
  } catch {
    return null;
  }
}